module.exports = __webpack_public_path__ + "assets/b4e4c9b501b5c53e5e38f923e02dd5bb.mp4";